

var grid = angular.module('grid', ["agGrid", "dialogs.main", "as.sortable", "ngDraggable"])
.service('GridVolatileStateManager', Grid.GridVolatileStateManager)
.service('GridPersistentStateManager', Grid.GridPersistentStateManager)
.service('GridTabsManager', Grid.GridTabsManager)

.service('GridHelpers', function($translate, $filter) {
	this.makeAgCellRenderer = function(field, $ctrl) {
		return Grid.AgCellRenderer(field, $ctrl, $translate, $filter);
	}
	this.makeGridOptions = function(gridOptions) {
		return Grid.makeGridOptions(gridOptions,$translate);
	}
})

.component('grid', Grid.AgGridComponent)
.component('gridPager', Grid.PagerComponent)
.component('gridFilter', Grid.FilterComponent)
.component('gridTabs', Grid.TabsComponent)
.directive('cmsGridFilter', Grid.FilterComponentField)

.directive('setToParentHeight', function($rootScope) {
    return function(scope, element, attrs) {
    	var evalHeight = function() {
    		return element.parent().outerHeight(true);
    	}
    	var deregister = $rootScope.$watch(evalHeight, function(h) {
    		if (element.closest('.ng-hide').length) {  // parent only
				return;
			}
    		if (element.parent().is(':visible') && h !== null && h != 0) {
    			var border = element.outerHeight() - element.innerHeight();
    			element.height(h - border);
    			element.show();
    		}
    	});
    	scope.$on('$destroy', function(){
    		deregister();
    	});
	}
})

